import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import { useCallback } from 'react';
import { IconButton } from 'rsuite';
import { TExpandableLicenseButtonProps } from './types';

export function ExpandableLicenseButton(props: TExpandableLicenseButtonProps) {
  const { index, isExpanded, handleExpand = () => {} } = props;

  const onClick = useCallback(() => handleExpand(index), [handleExpand, index]);

  const icon = isExpanded ? (
    <ArrowRightLineIcon aria-hidden />
  ) : (
    <ArrowLeftLineIcon aria-hidden />
  );

  const collapseExpand = isExpanded ? 'Collapse' : 'Expand';
  const label = `${collapseExpand} details`;

  return (
    <IconButton
      type="button"
      size="sm"
      icon={icon}
      onClick={onClick}
      aria-label={label}
      placement="left"
      css="width: 150px;"
    >
      {label}
    </IconButton>
  );
}
